// app/javascript/controllers/clickable_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    target: String,
    turboFrame: String,
    turbo: Boolean,
  };

  navigate(event) {
    event.preventDefault(); // Empêche le comportement par défaut
    const url = this.urlValue || this.element.dataset.url;
    const target = this.targetValue || this.element.dataset.target;
    const turboFrame = this.turboFrameValue || this.element.dataset.turboFrame;
    const turbo = this.turboValue || this.element.dataset.turbo;

    if (url === undefined) {
      return;
    }

    if (target !== undefined) {
      window.open(url, target);
    } else if (window.Turbo && turboFrame !== undefined) {
      window.Turbo.visit(url, { frame: turboFrame });
    } else if (window.Turbo && turbo !== 'false') {
      window.Turbo.visit(url);
    } else {
      window.location.href = url;
    }
  }
}
